<template>
    <div class="table-container">
        <div class="title">
            <span>
                Viber Campaigns
            </span>
            <div>
                <v-btn
                    :disabled="!hasCreatePrivilege"
                    class="edit-btn"
                    @click="goToCreateViberCampaign()"
                >
                    Create New
                </v-btn>
            </div>
        </div>
        <array-filters :is-search-in-progress="isFetchingCampaigns" />
        <array-view
            :items="viberCampaigns"
            :headers="headers"
            :total-pages="totalPages"
            :page="page"
            :size="size"
            :total-items="totalItems"
            :is-fetching="isFetchingCampaigns"
            :is-edit-disabled="!hasEditPrivilege"
            :is-delete-disabled="!hasDeletePrivilege"
            @refresh-data="refreshData"
            @paginationChange="paginationChange"
            @updateCampaign="updateCampaignItem"
            @deleteCampaign="deleteCampaign"
        />
    </div>
</template>

<script>
    import viberCampaignService from '@/services/viber-campaign-service'
    import ArrayFilters from '@/components/ArrayFilters'
    import ArrayView from '@/components/ArrayView'
    import { hasPrivilege } from '@/utils/userUtils'
    import { PRIVILEGES } from '@/utils/consts'
    export default {
        components: { ArrayView, ArrayFilters },
        data() {
            return {
                headers: [
                    {
                        text: 'Id',
                        value: 'id'
                    },
                    {
                        text: 'User',
                        value: 'username'
                    },
                    { text: 'Originator', value: 'originator' },
                    { text: 'Status', value: 'status' },
                    { text: 'Created At', value: 'createdAt' },
                    { text: 'Scheduled At', value: 'scheduledAt' },
                    { text: 'Started At', value: 'startedAt' },
                    { text: 'Completed At', value: 'completedAt' },
                    { text: 'Alias', value: 'alias' },
                    { text: 'TTL', value: 'ttl' },
                    { text: 'Fallback', value: 'fallback', align: 'center' },
                    { text: 'Actions', align: 'center', value: 'actions', sortable: false }
                ],
                viberCampaigns: null,
                totalPages: 0,
                size: 5,
                page: 1,
                totalItems: 0,
                isFetchingCampaigns: false
            }
        },
        computed: {
            arrayFilters() {
                return this.$store.getters.getCurrentArrayFilters
            },
            hasDeletePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.VIBER_CAMPAIGN_DELETE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasEditPrivilege() {
                return hasPrivilege(
                    PRIVILEGES.VIBER_CAMPAIGN_UPDATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            },
            hasCreatePrivilege() {
                return hasPrivilege(
                    PRIVILEGES.VIBER_CAMPAIGN_CREATE_PRIVILEGE,
                    this.$store.getters.getCurrentUserPrivileges
                )
            }
        },
        watch: {
            arrayFilters() {
                this.page = 1
                this.fetchAllViberCampaigns()
            }
        },
        created() {
            this.$store.dispatch('clearFiltersOnCreate')
            this.page = this.$route.query.page ? parseInt(this.$route.query.page) : this.page
            this.fetchAllViberCampaigns()
        },
        methods: {
            refreshData() {
                this.fetchAllViberCampaigns()
            },
            paginationChange(page, size) {
                this.size = size
                this.page = page
                this.fetchAllViberCampaigns()
            },
            goToCreateViberCampaign() {
                this.$router.push('/viber/create')
            },
            fetchAllViberCampaigns() {
                this.isFetchingCampaigns = true
                viberCampaignService.getAllViberCampaigns({ filter: this.arrayFilters, range: [this.page - 1, this.size] }).then(resp => {
                    this.viberCampaigns = resp.data.content
                    this.totalPages = resp.data.totalPages
                    this.totalItems = resp.data.totalElements
                }).finally(() => {
                    this.isFetchingCampaigns = false
                })
            },
            updateCampaignItem(campaignIndex, property, val) {
                const campaign = this.viberCampaigns.find(c => c.id === campaignIndex)
                campaign[property] = val
            },
            deleteCampaign(id) {
                this.viberCampaigns = this.viberCampaigns.filter(campaign => campaign.id !== id)
            }
        }
    }
</script>

<style scoped>
    .title {
        font-size: 1.5rem !important;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .edit-btn {
        text-transform: none !important;
        background: #00acd6 !important;
        color: white;
        margin: 15px auto;
    }

</style>
